export default __webpack_public_path__ + "static/media/edit.3e171e39.svg";